import * as React from "react";
import {createStyles, Theme, WithStyles, withStyles} from "@material-ui/core";
import {ReachElement, Svhc} from "../../store/reach/types";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {compose} from "redux";
import ReachTextField from "./ReachTextField";
import EditIcon from '@material-ui/icons/Edit';
import IconButton from "@material-ui/core/IconButton";
import {WithTranslation, withTranslation} from "react-i18next";
import Error from '@material-ui/icons/Error';
import Tooltip from "@material-ui/core/Tooltip";

type Props = WithTranslation & WithStyles & {
    svhc: Svhc;
    element: ReachElement;
    handleChange: (substanceId: number, propName: string) => (event: React.ChangeEvent) => void;
    editPart: (substanceId: number) => void;
}

class ReachTableRow extends React.Component<Props, {}> {
    render() {
        const svhc = this.props.svhc;
        const element = this.props.element;
        const classes = this.props.classes;
        const t = this.props.t;
        return (
            <TableRow key={svhc.id}>
                <TableCell padding={'none'} className={classes.idCell}>
                    {(!element || !element.validation || element.validation.length == 0) && svhc.id}
                    {element && element.validation && element.validation.length > 0 &&
                    <Tooltip title={element.validation.map(e => t(e)).join(' ')} interactive>
                        <Error color="error"/>
                    </Tooltip>}
                </TableCell>
                <TableCell padding={'none'} className={classes.tableCell}>{svhc.name}</TableCell>
                <TableCell padding={'none'} className={classes.tableCell}>{svhc.ec}</TableCell>
                <TableCell padding={'none'} className={classes.tableCell}>{svhc.cas}</TableCell>
                <TableCell padding={'none'}
                           className={classes.tableCell}>{svhc.indexNumber}</TableCell>
                <TableCell padding={'none'} className={classes.textFieldCell}>
                    <ReachTextField svhc={svhc} element={element} propName="product"
                                    handleChange={this.props.handleChange}/>
                </TableCell>
                <TableCell padding={'none'} className={classes.textFieldCell}>
                    <ReachTextField svhc={svhc} element={element} propName="productPackage"
                                    handleChange={this.props.handleChange}/>
                </TableCell>
                <TableCell padding={'none'} className={classes.textFieldCell}>
                    <ReachTextField svhc={svhc} element={element} propName="coveringBox"
                                    handleChange={this.props.handleChange}/>
                </TableCell>
                <TableCell padding={'none'} className={classes.tableCell}>
                    <IconButton aria-label={this.props.t('common.edit')}
                                onClick={() => this.props.editPart(svhc.id)}>
                        <EditIcon/>
                    </IconButton>
                </TableCell>
            </TableRow>
        );
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<{}>, nextContext: any): boolean {
        let update = (this.props.element.product !== nextProps.element.product
            || this.props.element.productPackage !== nextProps.element.productPackage
            || this.props.element.coveringBox !== nextProps.element.coveringBox);
        if (update) {
            console.log("update reach table row (substanceId:%d)", this.props.svhc.id);
        }
        return update;
    }
}

const styles = ({palette, spacing}: Theme) => createStyles({
    tableCell: {
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit
    },
    idCell: {
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit,
        minWidth: 25
    },
    textFieldCell: {
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit,
        minWidth: 100
    }
});

export default compose(
    withStyles(styles),
    withTranslation('common'),
)(ReachTableRow) as any;
